import { Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { NotFoundPage } from '../../routes/ErrorPages';

/**
 * Client-side gate for the `/admin/*` route group. Renders the
 * NotFound page (not a Forbidden, not a redirect) when the
 * authenticated user isn't staff — matches the server-side
 * `requireStaff` behavior of returning 404 instead of 403 so the
 * admin surface is invisible to probes (a 403 leaks the surface's
 * existence).
 *
 * Authoritative gate is server-side (`apps/api/src/auth.ts`); this
 * is purely a UX optimization that skips the "fetch and get a 404"
 * round-trip when we already know from `/me` that the user can't
 * access these routes.
 *
 * `RequireAuth` is the outer wrapper that ensures `user` is non-null
 * by the time we get here, so we only need to check `isStaff`.
 */
export function RequireStaff() {
  const { user } = useAuth();
  if (user?.isStaff !== true) {
    return <NotFoundPage />;
  }
  return <Outlet />;
}
